import * as Sentry from '@sentry/react';

export const initSentry = () => {
  const environment = import.meta.env.MODE;
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  
  if (!dsn) {
    console.warn('Sentry DSN not configured');
    return; // Exit early if no DSN
  }

  Sentry.init({
    dsn,
    environment,
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      // Filter out sensitive data
      if (event.request?.cookies) {
        delete event.request.cookies;
      }
      
      return event;
    },
    ignoreErrors: [
      // Ignore common browser errors
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      // Ignore Firebase auth popup errors
      'auth/popup-closed-by-user',
      'auth/cancelled-popup-request',
    ],
  });

  // Set app version tag
  Sentry.setTag('app_version', import.meta.env.VITE_APP_VERSION || 'unknown');
};

export const setSentryUser = (user: { id: string; email?: string; username?: string }) => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.username,
  });
};

export const clearSentryUser = () => {
  Sentry.setUser(null);
};

export const captureException = Sentry.captureException;
export const captureMessage = Sentry.captureMessage;
export const withProfiler = Sentry.withProfiler;
export const ErrorBoundary = Sentry.ErrorBoundary;